import React from 'react';
import { useSessionManager } from '@/hooks/useSessionManager';
import { usePermissions } from '@/hooks/usePermissions';

interface SessionInitializerProps {
  children: React.ReactNode;
}

/**
 * Composant qui initialise automatiquement la gestion des sessions
 * Doit être placé au niveau racine de l'application
 * Ne s'initialise que si l'utilisateur est authentifié
 */
const SessionInitializer: React.FC<SessionInitializerProps> = ({ children }) => {
  return (
    <>
      {/* Initialise automatiquement la gestion des sessions seulement si l'utilisateur est authentifié */}
      <SessionManagerWrapper />
      {children}
    </>
  );
};

const SessionManagerWrapper: React.FC = () => {
  // Toujours appeler les hooks, mais ils géreront eux-mêmes la logique conditionnelle
  useSessionManager();
  usePermissions();
  
  return null;
};

export default SessionInitializer;
